export function vehiculeReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_VEHICULE":            
        case "UPDATE_VEHICULE":
            let list = Object.assign({}, state);
            list[payload.equipement_id] = payload
        
            return list

        case "VEHICULE_LOAN_START":
            let list2 = Object.assign({}, state);
            list2[payload.loan_vehicule].equipement_available = false
            list2[payload.loan_vehicule].equipement_status = "loan"
            list2[payload.loan_vehicule].equipement_state_current = payload.loan_state_start
            list2[payload.loan_vehicule].equipement_remarks_current = payload.loan_remarks_start
            return list2

        case "VEHICULE_LOAN_END":
            let list3 = Object.assign({}, state);
            list3[payload.loan_vehicule].equipement_available = true
            list3[payload.loan_vehicule].equipement_status = ""
            list3[payload.loan_vehicule].equipement_state_current = payload.loan_state_end
            list3[payload.loan_vehicule].equipement_remarks_current = payload.loan_remarks_end

            return list3

        case "GET_VEHICULES":

            return payload
            
        default:
            return state;
    }
    
}